<h1>{{ 'EXTERNALREGISTRATIONFORM.TITLE' | translate }}</h1>
<div class="form-container">
<!--	<label id="radio-group-label">{{ 'EXTERNALREGISTRATIONFORM.ISB2B.PLACEHOLDER' | translate | uppercase }}</label>-->
<!--	<mat-radio-group aria-labelledby="radio-group-label" [(ngModel)]="member.isB2b">-->
<!--		<mat-radio-button [value]="true">{{ 'EXTERNALREGISTRATIONFORM.ISB2B.TRUE' | translate }}</mat-radio-button>-->
<!--		<mat-radio-button [value]="false">{{ 'EXTERNALREGISTRATIONFORM.ISB2B.FALSE' | translate }}</mat-radio-button>-->
<!--	</mat-radio-group>-->

	<def-b2b-registration-form *ngIf="member.isB2b" [member]="member"></def-b2b-registration-form>
	<def-b2c-registration-form *ngIf="false === member.isB2b" [member]="member"></def-b2c-registration-form>

	<button mat-flat-button
					color='primary'
					(click)="submitForm()"
					[disabled]="member.plainPassword === ''"
					*ngIf="currentSubscription?.closed !== false">
		{{ 'EXTERNALREGISTRATIONFORM.SUBMITFORM' | translate | uppercase }}
	</button>

	<mat-spinner diameter="50" *ngIf="currentSubscription?.closed === false"></mat-spinner>
</div>
